
export const dateToTime = (date) => {
  if (!date) return "00:00";
  return date.toTimeString().slice(0, 5);
};

export const unixToTime = (unix) => {
  return new Date(unix).toUTCString().slice(-12, -7);
}

export const timeToUnix = (time) => {
  if (!time) {
    return 0;
  }

  return time.split(":").reduce((previousValue, currentValue) => {
    return (Number(previousValue) * 60) + Number(currentValue);
  }) * 60000;
}

export const unixToNumber = (unix) => {
  return unix / 60000 / 60;
}

export const numberToUnix = (number) => {
  return Math.round(number * 60 * 60000)
}

export const numberToTime = (number) => {
  let trueNumber;
  if (typeof number !== "number") {
    trueNumber = Number(number);
  }

  if (isNaN(trueNumber)) {
    return "00:00";
  }

  return unixToTime(Math.round(number * 60 * 60000));
}

export const timeToNumber = (time) => {
  return unixToNumber(timeToUnix(time));
}

export const numberToPrettyStringTime = (time: number) => {
  const minutes =  Math.floor(time * 60);
  return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
}

export const roundUnixToHour = (time) => Math.round(time/1000/60/30) * 30 * 60 * 1000

